/*
 * Copyright (C) 2023 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { RestModule } from '@ngxp/rest';
import { ApiRootEffects } from './+state/api-root.effects';
import { ApiRootFacade } from './+state/api-root.facade';
import { API_ROOT_FEATURE_KEY, reducer } from './+state/api-root.reducer';
import { ApiRootRepository } from './api-root.repository';
import { ApiRootService } from './api-root.service';

@NgModule({
  imports: [
    CommonModule,
    RestModule,
    StoreModule.forFeature(API_ROOT_FEATURE_KEY, reducer),
    EffectsModule.forFeature([ApiRootEffects]),
  ],
  providers: [ApiRootService, ApiRootFacade, ApiRootRepository],
})
export class ApiRootModule {}
